import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconUnlock = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--unlock")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M11.3970052,2.02535187 C14.4639192,1.71556258 17.2665944,3.78013367 17.8800005,6.801005 C17.9899024,7.34224433 17.6402343,7.8700986 17.098995,7.98000051 C16.5577557,8.08990241 16.0299014,7.74023433 15.9199995,7.198995 C15.5110621,5.18508078 13.642612,3.80870005 11.5980027,4.01522625 C9.55339335,4.22175244 7.99793421,5.94398259 7.99999742,8 L7.99999742,8 L7.999,10.9996319 L19,11 C20.6568542,11 22,12.3431458 22,14 L22,21 C22,22.6568542 20.6568542,24 19,24 L5,24 C3.34314575,24 2,22.6568542 2,21 L2,14 C2,12.3431458 3.34314575,11 5,11 L5.999,10.9996319 L5.99999742,8.001005 C5.99697994,4.99554935 8.21489202,2.4646204 11.1683875,2.05282126 Z M19,13 L5,13 C4.44771525,13 4,13.4477153 4,14 L4,21 C4,21.5522847 4.44771525,22 5,22 L19,22 C19.5522847,22 20,21.5522847 20,21 L20,14 C20,13.4477153 19.5522847,13 19,13 Z" id="icon--centivo--unlock"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-678.000000, -1312.000000)"/>
          <g id="Icon/unlock">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--unlock"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--unlock"/>
          </g>
      </g>
  </IconWrapper>
)
